import { render } from "./installation-person-modal.vue?vue&type=template&id=64ef25d6"
import script from "./installation-person-modal.vue?vue&type=script&lang=js"
export * from "./installation-person-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__